define.alias("ember-math-helpers/helpers/atan2", "media/helpers/atan2");